import * as _ from 'lodash';
import { Locale } from "./../../../models/locale-model";
import { ActionTree } from "vuex";
import { IPropertyEditState } from "./property-states.store";
import propertyEditTypesStore, {
    PROJECT_STORE_TYPE
} from "./property-edit-types.store";
import {
    IPropertyModel,
    IPropertyDescriptionModel,
    IPropertyMultModel,
    IPropertyParameterModel,
    IPropertyListingModel
} from "../../../models/property";
import { DataHelper } from "../../../utils/data-helper";
import { IGenericObject } from "../../../models/common";
import { IAutoCompleteService } from "../../../services";
import { IAddressAutoComplete } from "../../../models/autocomplete";
import { IMediaPubPlan, isSamePubPlanRow } from "../../../models/property/property-publish-plan.model";
import {
    PROPERTY_TAB_FINANCE,
    PROPERTY_TAB_ROOM,
    PROPERTY_TAB_PUBTEXT,
    PROPERTY_TAB_DOCUMENTS,
    PROPERTY_TAB_PICTURES,
    PROPERTY_TAB_RELATION,
    PROPERTY_TAB_ENVIRONMENT,
    PROPERTY_TAB_CONSTRUCTION,
    PROPERTY_TAB_ENVIRONMENT_PICTURES,
    PROPERTY_TAB_EVOLUTION_PICTURES,
    PROJECT_TAB_BUILDING,
    PROPERTY_TAB_FEATURES,
    PROPERTY_TAB_PUBLISH_PLAN,
    PROPERTY_TAB_COSTS,
    PROPERTY_TAB_VIRTUAL_TOUR_VIDEO
} from "../../../common/property.constant";
import { GenericBaseParameter } from "../../../models/base-parameter";
import { IListing } from "../../../models/listing-base-model";
import { itemStateConstant } from "../../../common";
import moduleConstant from "../../../common/module-constant";
import { storeTypes } from "../..";
import { deepClone } from "fast-json-patch/lib/core";

// import propertyPictureTypesStore from "./property-picture/property-picture-types.store";

// const checkPropertyPictureWidth = (property) => {
//     if (property.Pictures && property.Pictures.length > 0) {
//         return property.Pictures.filter(x => x.WidthOfImage === 0);
//     }
//     return [];
// }

// const checkProjectPictureWidth = (project) => {
//     let pictures = [];
//     let evolution = [];
//     let environment = [];
//     if (project.Pictures.length > 0) {
//         pictures = project.Pictures.filter(x => x.WidthOfImage === 0);
//         pictures.forEach(element => {
//             element.type = PROPERTY_TAB_PICTURES;
//         });
//     }
//     if (project.ProjectEvolutionPictures && project.ProjectEvolutionPictures.length > 0) {
//         evolution = project.ProjectEvolutionPictures.filter(x => x.WidthOfImage === 0);
//         evolution.forEach(element => {
//             element.type = PROPERTY_TAB_EVOLUTION_PICTURES;
//         });
//     }
//     if (project.ProjectEvolutionPictures && project.ProjectEvolutionPictures.length > 0) {
//         environment = project.ProjectEnvironmentPictures.filter(x => x.WidthOfImage === 0);
//         environment.forEach(element => {
//             element.type = PROPERTY_TAB_ENVIRONMENT_PICTURES;
//         });
//     }
//     return [...pictures, ...evolution, ...environment];
// }

const actions = <ActionTree<IPropertyEditState, any>>{
    [propertyEditTypesStore.Get.NEW_PROPERTY]: (
        { getters, commit },
        { request, locales, langCode }
    ) => {
        return getters.service
            .initProperty(request)
            .then((property: IPropertyModel) => {
                const lang =
                    (locales.find((locale: Locale) => locale.code === langCode) || {})
                        .id || 0;
                const description: IPropertyDescriptionModel = property.Descriptions?.find(
                    description => description.LanguageId === lang
                );
                const subcategory: IPropertyMultModel = property.TypeOfProps?.find(
                    type => type.IsMain === true
                );
                property.Documents = [];
                property.Pictures = [];
                property.Relations = [];
                property.PublicUtilities = [];
                property.ChargeElements = [];
                property.Rooms = property.Rooms || [];
                property.TypeOfPropertyId = subcategory?.Id;

                commit(propertyEditTypesStore.Set.PROPERTY, property);
                commit(
                    propertyEditTypesStore.Set.ORIGIN_PROPERTY,
                    DataHelper.deepClone(property)
                );
                commit(propertyEditTypesStore.Set.PROPERTY_SUBCATEGORY, subcategory || {});
                commit(propertyEditTypesStore.Set.PROPERTY_DESCRIPTION, description);
                return Promise.resolve(true);
            });
    },

    [propertyEditTypesStore.Get.PROPERTY]: (
        { getters, commit },
        payload: {
            locales: Locale[];
            listOfTypes: IGenericObject[];
            langCode: string;
            propertyId: number;
            loadTabs: string[];
            signal?: AbortSignal;
        }
    ) => {
        return getters.service
            .getPropertyById(payload.propertyId, payload.loadTabs, payload.signal ? { signal: payload.signal } : undefined)
            .then((property: IPropertyModel) => {
                if (payload.signal?.aborted) return;
                // because object is null will do not return from service so we need init them before to avoid undefine value
                const subcategory: IPropertyMultModel = property.TypeOfProps.find(
                    type => type.IsMain === true
                );
                commit(propertyEditTypesStore.Set.PROPERTY, property);
                commit(
                    propertyEditTypesStore.Set.ORIGIN_PROPERTY,
                    DataHelper.deepClone<IPropertyModel>(property)
                );
                commit(
                    propertyEditTypesStore.Set.PROPERTY_SUBCATEGORY,
                    subcategory || {}
                );

                return Promise.resolve(true);
            })
            .catch(error => {
                if (payload.signal?.aborted) return;
                return Promise.reject(error);
            });
    },

    [propertyEditTypesStore.Set.REFRESH_PROPERTY_DATA]: (
        { getters, commit }, property: IPropertyModel
    ) => {
        const subcategory: IPropertyMultModel = property.TypeOfProps.find(
            type => type.IsMain === true
        );
        commit(propertyEditTypesStore.Set.PROPERTY, property);
        commit(propertyEditTypesStore.Set.ORIGIN_PROPERTY, DataHelper.deepClone<IPropertyModel>(property));
        commit(propertyEditTypesStore.Set.PROPERTY_SUBCATEGORY, subcategory || {});

        return Promise.resolve(true);
    },
    [propertyEditTypesStore.Get.LIST_OF_ADDRESSES]: (
        { commit },
        payload: {
            service: IAutoCompleteService;
            queryString: string;
            countryName: string;
        }
    ) => {
        if (payload.service === undefined) {
            return Promise.reject("AutocompeteService could not initialized");
        }
        return payload.service
            .getListOfAddresses(payload.queryString, payload.countryName)
            .then((listOfAddresses: IAddressAutoComplete[]) => {
                return Promise.resolve(listOfAddresses);
            })
            .catch(error => Promise.reject(error));
    },

    [propertyEditTypesStore.Set.INSERT_PROPERTY]: ({ getters, commit }, option) => {
        const propertyInfo = deepClone(getters.property);
        delete propertyInfo.IsCommonCountry;

        commit(propertyEditTypesStore.Set.SET_IS_SAVING, true);
        return getters.service
            .insertProperty(propertyInfo)
            .then(result => {

                commit('common/setNotificationMessage', { type: 'success', action: 'ADD', module: 'OBJECT', id: option.tempId, newId: result.CreatedId, ref: getters.property.Reference }, { root: true })
                commit(propertyEditTypesStore.Set.REMOVE_MEDIA_PUBLIC_PLANS, option.tempId);
                return Promise.resolve(result);
            })
            .catch(error => {
                commit(propertyEditTypesStore.Set.SET_IS_SAVING, false);
                if (error.errorCode !== -1000) {
                    // skipSentry: the form's onSavePropertyError captures the original
                    // error; capturing the toast here too would duplicate the event.
                    commit('common/setNotificationMessage', { type: 'error', action: 'ADD', module: 'OBJECT', message: error, id: option.tempId, ref: getters.property.Reference, skipSentry: true }, { root: true })
                }
                return Promise.reject(error)
            });
    },
    [propertyEditTypesStore.Set.UPDATE_PROPERTY]: ({ getters, commit }, option) => {
        let propertyInfo = deepClone(getters.property);
        let originalPropertyInfo = deepClone(getters.originalProperty);

        // Iterate over both propertyInfo and originalPropertyInfo
        [propertyInfo, originalPropertyInfo].forEach(info => {
          // Unset 'ShortName' from all objects in the Relations array
          _.forEach(info.Relations, relation => _.unset(relation, 'ShortName'));

          // Unset 'updateKey' from all objects in the Pictures array
          _.forEach(info.Pictures, picture => _.unset(picture, 'updateKey'));
        });

        const config = option.config.params ? option.config  : {}
        delete propertyInfo.IsCommonCountry;

        commit(propertyEditTypesStore.Set.SET_IS_SAVING, true);
        return getters.service
            .updateProperty(propertyInfo, originalPropertyInfo , config)
            .then(result => {
                // SWA-7437: the type-change warning latch is deliberately NOT
                // re-armed here. Re-arming from hasPersistedPortalPlans (latch OR
                // live flag) made it sticky for the whole session, so every later
                // type touch warned even after the publications were gone - the
                // popup spam this ticket exists to remove. Restoring the latch
                // correctly needs the server's post-save HasSelectedPortal, which
                // the update response does not carry today.
                commit(propertyEditTypesStore.Set.ORIGIN_PROPERTY, DataHelper.deepClone<IPropertyModel>(getters.property));
                commit('common/setNotificationMessage',
                    {
                        type: 'success',
                        action: 'M_EDIT_NEW',
                        module: 'OBJECT',
                        id: getters.property.Id,
                        ref: getters.property.Reference
                    }, { root: true });
                return Promise.resolve(result);
            })
            .catch(error => {
                commit(propertyEditTypesStore.Set.SET_IS_SAVING, false);
                if (error.code === 20506) {
                    commit('common/setVisibleConflictDataInfo', { module: moduleConstant.Object, id: getters.property.Id, data: { entity: getters.property, origin: getters.originalProperty } }, { root: true });
                    return Promise.reject(error);;
                }
                if (error.code === 20510) {
                    commit(propertyEditTypesStore.Set.RESET_PICTURE_TAB);
                }
                if (error.errorCode !== -1000) {
                    // skipSentry: the form's onSavePropertyError captures the original
                    // error; capturing the toast here too would duplicate the event.
                    commit('common/setNotificationMessage', { type: 'error', action: 'M_EDIT_NEW', module: 'OBJECT', message: error, id: getters.property.Id, ref: getters.property.Reference, skipSentry: true }, { root: true })
                }
                return Promise.reject(error);
            });
    },
    [propertyEditTypesStore.Set.DELETE_PROPERTY]: (
        { getters },
        ids: number[]
    ) => {
        return getters.service[propertyEditTypesStore.Set.DELETE_PROPERTY](ids)
            .then(() => {
                return Promise.resolve(true);
            })
            .catch(ex => {
                return Promise.reject(ex);
            });
    },

    [propertyEditTypesStore.Get.CONTENT_BY_TAB]: (
        { commit, getters },
        payload: any
    ) => {
        const propertyAttributes = Object.keys(getters.property);
        let propertyName: string;
        let tabName: string;
        let extension: any = null;

        if (typeof payload === 'object') {
            tabName = payload.tabName;
            extension = payload.extension
        }

        if (typeof payload === 'string') {
            tabName = payload;
        }

        //#Check tab storage already in store, should return from store;
        if (
            tabName == PROPERTY_TAB_FINANCE &&
            propertyAttributes.indexOf("ChargeElements") >= 0 &&
            propertyAttributes.indexOf("PublicUtilities") >= 0 &&
            propertyAttributes.indexOf("LinkedUnits") >= 0
        ) {
            return;
        }

        switch (tabName) {
            case PROPERTY_TAB_ROOM:
                propertyName = "Rooms";
                break;
            case PROPERTY_TAB_PUBTEXT:
                propertyName = "Descriptions";
                break;
            case PROPERTY_TAB_DOCUMENTS:
                propertyName = "Documents";
                break;
            case PROPERTY_TAB_PICTURES:
                propertyName = "Pictures";
                break;
            case PROPERTY_TAB_ENVIRONMENT_PICTURES:
                propertyName = "ProjectEnvironmentPictures";
                break;
            case PROPERTY_TAB_EVOLUTION_PICTURES:
                propertyName = "ProjectEvolutionPictures";
                break;
            case PROPERTY_TAB_PUBLISH_PLAN:
                propertyName = "MediaPubPlans";
                break;
            case PROPERTY_TAB_FEATURES:
                propertyName = "ProjectFeatures";
                break;
            case PROPERTY_TAB_RELATION:
                propertyName = "Relations";
                break;
            case PROPERTY_TAB_ENVIRONMENT:
                propertyName = "Environments";
                break;
            case PROPERTY_TAB_FINANCE:
                propertyName = "Finance";
                break;
            case PROPERTY_TAB_CONSTRUCTION:
                propertyName = "GeneralConstruction";
                break;
            case PROJECT_TAB_BUILDING:
                propertyName = "ProjectBuildings";
                break;
            case PROPERTY_TAB_COSTS:
                propertyName = "Costs";
                break;
            case PROPERTY_TAB_VIRTUAL_TOUR_VIDEO:
                propertyName = "Videos";
                break;
            default:
                propertyName = "None";
                break;
        }

        const allowUpdateAttribute = propertyAttributes.indexOf(propertyName) === -1 || getters.property[propertyName].length == 0;
        let requestHold: Promise<any>;
        if (getters.property.ConstructionType == 1) {
            requestHold = getters.projectServices[
                PROJECT_STORE_TYPE.GET.PROJECT_GET_CONTENT_BY_TAB_NAME
            ](getters.property, tabName, propertyName);
        } else {
            requestHold = getters.service[propertyEditTypesStore.Get.CONTENT_BY_TAB](
                getters.property,
                tabName,
                propertyName,
                extension
            );
        }

        return requestHold
            .then(payload => {
                // WA-3296 Check if rooms tab already loaded (remove Room in payload)
                if (tabName === PROPERTY_TAB_PICTURES && getters.property.Rooms) {
                    delete payload.Rooms;
                }
                commit(propertyEditTypesStore.Set.ASSIGNVALUE, payload);
                if (getters.property.Id > 0 && propertyName !== "None" && allowUpdateAttribute) {
                    commit(propertyEditTypesStore.Set.ASSIGNVALUE_TO_ORIGINOBJECT, DataHelper.deepClone(payload));
                }

                return Promise.resolve(true);
            }).catch(ex => {
                return Promise.reject(ex);
            });
    },

    [propertyEditTypesStore.Set.LIST_OF_PUBLISH_PLAN]: ({ commit, state }, payload) => {
        // Reconcile regenerate (proposed portals) against originalProperty (server state) so
        // the JSON-Patch diff stays index-aligned with the BE — otherwise `replace /MediaPubPlans/N`
        // points past the server's array. New portals become Added, dropped portals become Deleted.
        const regenerated: IMediaPubPlan[] = (payload && payload.MediaPubPlans) || [];
        const original: IMediaPubPlan[] =
            (state.originalProperty && state.originalProperty.MediaPubPlans) || [];

        const reconciled: IMediaPubPlan[] = original.map(orig => {
            const clone = DataHelper.deepClone<IMediaPubPlan>(orig);
            if (clone.Id > 0 && !regenerated.some(r => isSamePubPlanRow(r, clone))) {
                clone.ItemState = itemStateConstant.Deleted;
            }
            return clone;
        });

        regenerated.forEach(r => {
            if (!original.some(o => isSamePubPlanRow(o, r))) {
                const added = DataHelper.deepClone<IMediaPubPlan>(r);
                added.ItemState = itemStateConstant.Added;
                reconciled.push(added);
            }
        });

        commit(propertyEditTypesStore.Set.ASSIGNVALUE, { MediaPubPlans: reconciled });
        return Promise.resolve(true);
    },
    [propertyEditTypesStore.Set.UPDATE_PROPERTY_PROP_ELEMENT]: (
        { commit },
        payload
    ) => {
        //payload {prop,index,data}
        commit(propertyEditTypesStore.Set.UPDATE_PROPERTY_PROP_ELEMENT, payload);
        commit(propertyEditTypesStore.Set.HAS_SELECTED_PORTAL);
        return Promise.resolve(true);
    },
    [propertyEditTypesStore.Set.ADD_PROPERTY_PROP_ELEMENT]: (
        { commit },
        payload
    ) => {
        //payload {prop,index,data}
        commit(propertyEditTypesStore.Set.ADD_PROPERTY_PROP_ELEMENT, payload);

        return Promise.resolve(true);
    },
    [propertyEditTypesStore.Set.DELETE_PROPERTY_PROP_ELEMENT]: (
        { commit },
        payload
    ) => {
        //payload {prop,index,data}
        commit(propertyEditTypesStore.Set.DELETE_PROPERTY_PROP_ELEMENT, payload);

        return Promise.resolve(true);
    },
    // Project
    [PROJECT_STORE_TYPE.GET.PROJECT_BY_ID]: (
        { getters, commit },
        payload: {
            locales: Locale[];
            listOfTypes: IGenericObject[];
            langCode: string;
            projectId: number;
            loadTabs: string[];
        }
    ) => {
        return getters.projectServices
            .getProjectById(payload.projectId, payload.loadTabs)
            .then((property: IPropertyModel) => {
                commit(propertyEditTypesStore.Set.PROPERTY, property);
                commit(
                    propertyEditTypesStore.Set.ORIGIN_PROPERTY,
                    DataHelper.deepClone<IPropertyModel>(property)
                );
                return Promise.resolve(true);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    },

    [PROJECT_STORE_TYPE.GET.UNITS_OF_BUILDING]: (
        { getters, commit },
        payload: {
            projectId: number;
            buildingId: number,
            params: GenericBaseParameter<any>
        }
    ) => {
        return getters.projectServices
            .loadUnitsByBuildingId(payload)
            .then((response: any) => {
                if (response.listOfItems) {
                    commit(storeTypes.Set.ASSIGNVALUE_TO_ORIGINBUILDING_UNIT, { id: payload.buildingId, value: { Units: response.listOfItems } });
                    commit(storeTypes.Set.ASSIGNVALUE_PROJECT_BUILDING_UNITS, { id: payload.buildingId, value: { Units: response.listOfItems } });
                }
                return Promise.resolve(true);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    },

    [PROJECT_STORE_TYPE.SET.REFRESH_DATA]: (
        { getters, commit },
        property: IPropertyModel
    ) => {
        commit(propertyEditTypesStore.Set.PROPERTY, property);
        commit(
            propertyEditTypesStore.Set.ORIGIN_PROPERTY,
            DataHelper.deepClone<IPropertyModel>(property)
        );
        return Promise.resolve(true);
    },

    [PROJECT_STORE_TYPE.GET.PROJECT_NEW]: (
        { getters, commit },
        { locales, langCode }
    ) => {
        return getters.projectServices
            .initProject()
            .then((property: IPropertyModel) => {
                commit(propertyEditTypesStore.Set.PROPERTY, property);
                commit(
                    propertyEditTypesStore.Set.ORIGIN_PROPERTY,
                    DataHelper.deepClone(property)
                );
                return Promise.resolve(true);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    },

    [PROJECT_STORE_TYPE.SET.PROJECT_INSERT]: ({ getters, commit }, option) => {
        commit(propertyEditTypesStore.Set.SET_IS_SAVING, true);
        return getters.projectServices
            .insertProject(getters.property)
            .then(result => {

                commit('common/setNotificationMessage', { type: 'success', action: 'ADD', module: 'PROJECT', id: option.tempId, newId: result.CreatedId, ref: getters.property.Reference }, { root: true })
                return Promise.resolve(result);
            })
            .catch(error => {
                commit(propertyEditTypesStore.Set.SET_IS_SAVING, false);
                if (error.errorCode !== -1000) {
                    // skipSentry: the form's onSaveProjectError captures the original
                    // error; capturing the toast here too would duplicate the event.
                    commit('common/setNotificationMessage', { type: 'error', action: 'ADD', module: 'PROJECT', message: error?.data?.msg || error?.message, id: option.tempId, ref: getters.property.Reference, skipSentry: true }, { root: true })
                }
                return Promise.reject(error)
            });
    },

    [PROJECT_STORE_TYPE.SET.PROJECT_UPDATE]: ({ getters, commit }) => {
        let propertyInfo = deepClone(getters.property);
        let originalPropertyInfo = deepClone(getters.originalProperty);
        delete propertyInfo.ProjectGeneral.IsCommonCountry;

        [propertyInfo, originalPropertyInfo].forEach(info => {
            // Unset 'ShortName' from all objects in the Relations array
            _.forEach(info.Relations, relation => _.unset(relation, 'ShortName'));

            // Unset 'updateKey' from all objects in the Pictures array
            _.forEach(info.Pictures, picture => _.unset(picture, 'updateKey'));
          });

        commit(propertyEditTypesStore.Set.SET_IS_SAVING, true);
        return getters.projectServices
            .updateProject(propertyInfo, originalPropertyInfo)
            .then(result => {

                commit(propertyEditTypesStore.Set.ORIGIN_PROPERTY, DataHelper.deepClone<IPropertyModel>(getters.property));
                commit('common/setNotificationMessage', { type: 'success', action: 'M_EDIT_NEW', module: 'PROJECT', id: getters.property.ProjectId, ref: getters.property.Reference }, { root: true });
                return Promise.resolve(result);
            })
            .catch(error => {
                commit(propertyEditTypesStore.Set.SET_IS_SAVING, false);
                if (error.code === 20506) {
                    commit('common/setVisibleConflictDataInfo', { module: moduleConstant.Project, id: getters.property.ProjectId, data: { entity: getters.property, origin: getters.originalProperty } }, { root: true });
                    return Promise.reject(error);;
                }
                if (error.code === 20510) {
                    commit(propertyEditTypesStore.Set.RESET_PICTURE_TAB);
                }
                if (error.errorCode !== -1000) {
                    // skipSentry: the form's onSaveProjectError captures the original
                    // error; capturing the toast here too would duplicate the event.
                    commit('common/setNotificationMessage', { type: 'error', action: 'M_EDIT_NEW', module: 'PROJECT', message: error?.data?.msg || error?.message, id: getters.property.ProjectId, ref: getters.property.Reference, skipSentry: true }, { root: true })
                }
                return Promise.reject(error)
            });
    },
    [PROJECT_STORE_TYPE.GET.PROJECT_BUILDING_INIT]: ({ getters }, payload) => {
        return Promise.resolve(getters.projectServices.projectBuildingInit(payload).next().value)
    },
    [PROJECT_STORE_TYPE.GET.LIST_OF_PROJECT_UNITS]: (
        { getters, commit },
        param: GenericBaseParameter<IPropertyParameterModel>
    ) => {
        return getters.projectServices
            .getListOfProjectUnits(param)
            .then((listingResult: IListing<IPropertyListingModel>) => {
                return Promise.resolve(listingResult);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    },
    [PROJECT_STORE_TYPE.GET.LIST_OF_FINANCE_LINKED_UNITS]: (
        { getters, commit },
        param: any
    ) => {
        let linkedUnits = getters.property.LinkedUnits || [];
        let activeLinkedUnits = linkedUnits.filter(r => r.ItemState != itemStateConstant.Deleted);
        let excludeIds = activeLinkedUnits.map(r => r.UnitPropertyId);

        param.Condition.ExcludeIds = excludeIds;
        param.Fields = "Id,Purpose,Reference,PriceAndUnit,Bedrooms,Status,SubStatus,TypeDesc,Street,CityName,CityPostcode,TotalArea,RecordFile,ProjectName,ProjectId,BuildingId,Construction,GroundPart,Price,Share,BaseActualCost";

        return getters.projectServices
            .getListOfFinanceLinkedUnits(getters.property.ProjectId, param)
            .then((listingResult: IListing<IPropertyListingModel>) => {
                return Promise.resolve(listingResult);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    },
    [propertyEditTypesStore.Get.MEDIA_PUBLIC_PLANS]: ({ getters }, ObjectId: number) => {
        const mediaPubPlans = getters.getMediaPublicPlans && getters.getMediaPublicPlans.length && getters.getMediaPublicPlans.find(x => x.ObjectId === ObjectId);
        return mediaPubPlans || [];
    },
};

export default actions;
